import { Box,  Grid } from '@mui/material';
import * as React from 'react';
import { VendorMapSelectControl } from './VendorMapSelect';
import { formatNumber } from '../Common/Utilities';
export function InvoiceDetailFields(props) {

	const fieldList = React.useMemo(() => {
		return [{
			label: 'IO/PO Number',
			type: 'string',
			field: 'ioNumber',
			notVisible: false,
			disbaled: props.readOnly,
		},
		{
			label: 'IO/PO Description',
			type: 'string',
			field: 'ioDescription',
			notVisible: false,
			disbaled: props.readOnly,
		},
		{
			label: 'IO/PO Net Amount',
			type: 'currency',
			field: 'ioInvoiceAmount',
			notVisible: false,
			disbaled: props.readOnly,
			//transformer: (value) => value && formatNumber(value)
		}
		]
	});

	return (<><div className="mf-12">
		<Box>
			{
				fieldList.map((item, index) => {
					return (!item.notVisible ? < Grid container item key={ index} spacing = { props.style.mainRowSpacing } sx = { props.style.mainRowStyle } >
						<Grid item key={ 'a'+ index} xs={props.style.cellOneWidth} sx={props.style.cellOneStyle}><label>{ item.label}</label></Grid>
						{
							<Grid item key={'b' + index} xs={props.style.cellTwoWidth}
								style={{ display: props.advanceEdit ? 'block' : 'none' }}
								sx={props.style.cellTwoStyle}>
							<VendorMapSelectControl
								style={props.style} fieldData={props?.fieldData}
								recordType={'Lineitems'}
								value={props?.mappedFields[item.field]}
									type={item.type}
									regex={props.regex}
								maxWeightedLine={props.maxWeightedLine}
									controlKey={'Detials' + index}
									readOnly={props.readOnly}
								onChange={(event) => {
									props.field_changehandler({ event: event, value: item.field })
								}}
							>
							</VendorMapSelectControl></Grid>
						}
						<Grid item key={'c' + index} xs={props.style.cellThreeWidth} sx={props.style.cellThreeStyle}>
							<input disabled type={'text'}
								className={`${(props.regex[item.type] || [])?.some(e => e.test(props?.mappedFields[item.field]?.value)) || item.type === 'string'
									|| (props?.mappedFields[item.field]?.value || '') === '' ? '' : 'border-red'}`}
								value={item.transformer ? item.transformer(props?.mappedFields[item.field]?.value) : props?.mappedFields[item.field]?.value}
								style={{
									...props.style.inputStyle,
									textAlign: item.type.indexOf('currency') != -1 && props.regex['currency']?.some(e => e.test(props?.mappedFields[item.field]?.value)) ? 'right' : 'left'
								}} /></Grid>
					</Grid> : <></>)
				})
			}			
		</Box>
	</div></>);
}